export enum UserRoles {
    User = 0,
    Admin = 1,
    InvitedUser = 2,
    InvitedAdmin = 3
}